var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinbaseWalletLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H6C2.68629 0 0 2.68629 0 6V26C0 29.3137 2.68629 32 6 32H26C29.3137 32 32 29.3137 32 26V6C32 2.68629 29.3137 0 26 0Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66496 0H25.3338C29.0163 0 32 3.21024 32 7.17056V24.8294C32 28.7898 29.0163 32 25.335 32H6.66496C2.98368 32 0 28.7898 0 24.8294V7.17056C0 3.21024 2.98368 0 6.66496 0Z",
    fill: "#0052FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 4.63489C22.277 4.63489 27.365 9.72289 27.365 16C27.365 22.2771 22.277 27.3651 15.9999 27.3651C9.72277 27.3651 4.63477 22.2771 4.63477 16C4.63477 9.72289 9.72277 4.63489 15.9999 4.63489Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2007 12.3674H18.7982C19.259 12.3674 19.6314 12.7693 19.6314 13.2634V18.7354C19.6314 19.2307 19.2577 19.6314 18.7982 19.6314H13.2007C12.7399 19.6314 12.3674 19.2294 12.3674 18.7354V13.2634C12.3674 12.7693 12.7412 12.3674 13.2007 12.3674Z",
    fill: "#0052FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseWalletLogo);
export default __webpack_public_path__ + "static/media/coinbase-wallet-logo.58ee184c.svg";
export { ForwardRef as ReactComponent };